import Head from 'next/head'
import { useRouter } from 'next/router'
import React from 'react'
import { imageServerUrl } from '../../helpers/common'
import { useStore } from '../../store'
import Script from 'next/script'
import { colors } from '@microfrontends/react-components'

export default function MetaTags() {
    const { t } = useStore().state
    const router = useRouter()

    const url = `${process.env.NEXT_PUBLIC_VNW_JOBSEEKER_URL}${router.asPath}`
    const favicon = `${process.env.NEXT_PUBLIC_VNW_JOBSEEKER_URL}/favicon.ico?v=${process.env.BUILD_ID}`

    return (
        <>
            <Head>
                <title>{t('meta_title')} | VietnamWorks</title>
                <meta charSet='utf-8' />
                <meta
                    name='viewport'
                    content='width=device-width, initial-scale=1.0 maximum-scale=1.0, user-scalable=no'
                />
                <meta httpEquiv='X-UA-Compatible' content='IE=edge' />
                <link rel='shortcut icon' href={favicon} type='image/x-icon' />
                <meta name='description' content={t('meta_description')} />
                <meta name='theme-color' content={colors.primary[20]} />
                <meta name='robots' content='noindex, nofollow' />
                <link rel='canonical' href={url} />
            </Head>

            <Script
                id='ga'
                dangerouslySetInnerHTML={{
                    __html: `
                    var _gaq = _gaq || [];
                    var pluginUrl = '//www.google-analytics.com/plugins/ga/inpage_linkid.js';
                    _gaq.push(['_require', 'inpage_linkid', pluginUrl]);
                    _gaq.push(['_setAccount', '${process.env.NEXT_PUBLIC_GA_ACCOUNT}']);
                    _gaq.push(['_setDomainName', '${process.env.NEXT_PUBLIC_GA_DOMAIN}']);
                    _gaq.push(['_trackPageview']);

                    (function() {
                        var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
                        ga.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'stats.g.doubleclick.net/dc.js';
                        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
                    })();
                    function customEvent (uniqueName, action, label, value) {
                        if (_gaq) {
                            _gaq.push(['_trackEvent', uniqueName, action, label], value || 1); // 'Videos', 'Play', 'First Birthday'
                        }
                    }`
                }}
            />
            <Script
                id='gtm'
                dangerouslySetInnerHTML={{
                    __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID}');`
                }}
            />
            <Script async src={`${process.env.NEXT_PUBLIC_VNW_BASE_URL}/assets-page-container/js/jquery.min.js`} />
        </>
    )
}
